(function () {
    "use strict";

    angular
        .module('components')
        .component('hNumericInput', {
            bindings: {
                placeholder: '@',
                cssClass: '@',
                ngChange: '&',
                ngDisabled: '<?',
                ngModel: '=',
                minValue: '<?',
                maxValue: '<?',
                step: '<?',
                name: '<?',
                hName: '<?'
            },
            controller: HNumericInputComponent,
            controllerAs: 'hNumericInputComponent',
            templateUrl: '../hmodules/components/h-numeric-input/h-numeric-input.component.ng.html'
        });

    HNumericInputComponent.$inject = ['$scope', '$element', '$timeout'];

    function HNumericInputComponent($scope, $element, $timeout) {
        var self = this;

        self.$onInit = function () {
            self.step = self.step || 1;
            self.placeholder = self.placeholder || '';
            self.name = self.name || self.hName;
            $element.find('input').on('keydown', function (e) {
                if (e.keyCode === 38) {
                    // up key
                    e.preventDefault();
                    self.increment();
                } else if (e.keyCode === 40) {
                    // down key
                    e.preventDefault();
                    self.decrement();
                }
            });
        };

        self.increment = function () {
            if (self.ngModel !== null && self.ngModel !== undefined) {
                if (self.ngModel === self.maxValue) {
                    return;
                }

                if (self.maxValue === null || self.maxValue === undefined || self.ngModel + self.step <= self.maxValue) {
                    self.ngModel = self.ngModel + self.step;
                } else {
                    self.ngModel = self.maxValue;
                }
            } else {
                self.ngModel = ensureValueWithinRange(self.step, self.minValue, self.maxValue);
            }
            onChange();
        };

        self.decrement = function () {
            if (self.ngModel !== null && self.ngModel !== undefined) {
                if (self.ngModel === self.minValue) {
                    return;
                }

                if (self.minValue === null || self.minValue === undefined || self.ngModel - self.step >= self.minValue) {
                    self.ngModel = self.ngModel - self.step;
                } else {
                    self.ngModel = self.minValue;
                }
            } else {
                self.ngModel = ensureValueWithinRange(-self.step, self.minValue, self.maxValue);
            }
            onChange();
        };

        var ensureValueWithinRange = function (value, minValue, maxValue) {
            if (value < minValue) {
                value = minValue;
            } else if (value > maxValue) {
                value = maxValue;
            }
            return value;
        };

        var onChange = function () {
            $timeout(function () {
                self.ngChange({value: self.ngModel});
                $element.find('input').change();
            }, 100);
        };
    }

})();
